var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleExclamationSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 -9.5399e-08C5.37188 -6.74848e-07 1.62852e-06 5.37187 1.04907e-06 12C4.69624e-07 18.6281 5.37188 24 12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 4.8405e-07 12 -9.5399e-08ZM12 18C11.3766 18 10.875 17.4984 10.875 16.875L10.875 11.625C10.875 11.0016 11.3766 10.5 12 10.5C12.6234 10.5 13.125 11.0016 13.125 11.625L13.125 16.875C13.125 17.4984 12.6234 18 12 18ZM10.5 7.5C10.5 6.67031 11.1703 6 12 6C12.8297 6 13.5 6.67031 13.5 7.5C13.5 8.32969 12.8297 9 12 9C11.1703 9 10.5 8.32969 10.5 7.5Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleExclamationSolid);
export default __webpack_public_path__ + "static/media/circle-exclamation-solid.4c6c77fd3f328e9870856c28c4a2aadd.svg";
export { ForwardRef as ReactComponent };